// ============================================================================
// BELLMAN-FORD - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'bellman-ford',
  name: 'Bellman-Ford',
  category: 'Graphs',
  complexity: {
    time: 'O(VE)',
    space: 'O(V)'
  },
  description: 'A single-source shortest path algorithm that computes shortest paths from a source vertex to all other vertices in a weighted digraph. Unlike Dijkstra, it can handle negative edge weights and detect negative cycles.'
};
